import React, { Component } from "react";
import { connect } from "react-redux";
import classNames from "classnames";
import './styles.scss';
import Logo from 'assets/img/PayPair_Logo.png';
import { providerLogos } from 'components/DataDisplay/LogoView/constant';
import { affiliatedProviderSelector } from 'containers/MultistepForm/selectors';

const AFFILIATED_LOGO_PROVIDERS = ['progressive'];

class ModalHeader extends Component {
  render() {
    const { affiliatedProvider } = this.props;
    const showProviderLogo = AFFILIATED_LOGO_PROVIDERS.includes(affiliatedProvider)
      && !!providerLogos[affiliatedProvider];

    return <div className="flex flex--column flex__align--center multistep-modal-header">
      <div className={classNames("multistep-modal-header__logo", {
        "multistep-modal-header__logo--combined": showProviderLogo
      })}>
        <img src={Logo} alt="tireagent logo" />
        {showProviderLogo && (
          <img
            className="multistep-modal-header__provider-logo"
            src={providerLogos[affiliatedProvider].img}
            alt={`${affiliatedProvider} logo`}
          />
        )}
      </div>
      {/* <h1 className="multistep-modal-header__title">Shop Now, Pay Over Time</h1> */}
    </div>
  }
}

export default connect(state => ({
  affiliatedProvider: affiliatedProviderSelector()(state),
}))(ModalHeader);
